import { render, staticRenderFns } from "./block-offer.vue?vue&type=template&id=ac9942a0&scoped=true"
import script from "./block-offer.vue?vue&type=script&lang=js"
export * from "./block-offer.vue?vue&type=script&lang=js"
import style0 from "./block-offer.vue?vue&type=style&index=0&id=ac9942a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9942a0",
  null
  
)

export default component.exports